<template>
  <div class="hello">
  <el-backtop target="" :bottom="100"></el-backtop>
    <el-carousel class="height" :interval="15000" :style="style" arrow="always">
      <el-carousel-item class="carousel-wrap height"  :style="style">
        <AboutHome></AboutHome>
        <!-- <div class="carousel-wrap">
          <div class="carousel-graphic">
            <img src="../assets/logo.png">
          </div>
          <div class="carousel-text">
            <h1>全国专业化、效率化、系统化酒店外包人力资源服务平台，值得你们的信赖！</h1>
            <p>提供专业的酒店保洁人力服务撮合平台，酒店保洁流程线上化和步骤化、保证保洁质量和提高结算效率。体系化、专业化、、多样化酒店保洁服务人员培训课程</p>
            <div class="carousel-code">
              <div class="footer-top-join">
                <img src="../assets/logo.png">
                <p>酒店保洁人员</p>
              </div>
              <div class="footer-top-down">
                <img src="../assets/logo.png">
                <p>酒店与人力服务公司</p>
              </div>
            </div>
          </div>
        </div> -->
      </el-carousel-item>
      <el-carousel-item  class="height" :style="style">
        <AboutOur></AboutOur>
       <!-- <div class="carousel-wrap">
          <div class="carousel-app">
            <img src="../assets/logo.png">
          </div>
          <div class="carousel-app-introduce">
            <div class="carousel-app-circle">
              <span class="circle" style="position: absolute;top: 20px;left: 10px">入驻</span>
              <span class="circle" style="position: absolute;top: 100px;left: 100px">注册</span>
              <span class="circle" style="position: absolute;top: 20px;left: 190px">培训</span>
              <span class="circle" style="position: absolute;top: 100px;left: 280px">派工</span>
              <span class="circle" style="position: absolute;top: 20px;left: 370px">派单</span>
              <span class="circle" style="position: absolute;top: 100px;left: 460px">保洁</span>
              <span class="circle" style="position: absolute;top: 20px;left: 540px">验收</span>
              <span class="circle" style="position: absolute;top: 100px;left: 630px">对账</span>
            </div>
            <div class="carousel-app-text">
              <p><b>注册与入住：</b><span>酒店和人力工资进行入驻信息填写和员工注册，管理员工基本信息。</span></p>
              <p><b>保洁流程管理：</b><span>从派工、派单、保洁、验收进行酒店保洁线上全流程管理。</span></p>
              <p><b>对账与结算：</b><span>系统每日、月生成对账单，进行保洁工单的核对，无需纸质核对，系统记录交易一目了然。</span></p>
              <p><b>培训与考试：</b><span>所有酒店保洁员工经过专业、体系的保洁 课程培训和考试，合格者上岗保洁。</span></p>
            </div>
          </div>
        </div>-->
      </el-carousel-item>
      <el-carousel-item  class="height" :style="style">
        <AboutOurThree></AboutOurThree>
        <!-- <div class="carousel-wrap">
           <div class="carousel-cooperate">
             <h2>我们的合作机构</h2>
           </div>
           <div class="carousel-cooperate-list">
             <img v-for="(v,index) in cooperateList" :key="index" :src="v.cooperateUrl">
           </div>
         </div>-->
      </el-carousel-item>
    </el-carousel>
  </div>
</template>

<script>
    import AboutHome from '../components/AboutHome';
    import AboutOur from "../components/AboutOur";
    import AboutOurThree from "../components/AboutOurThree";
    import {throttle} from 'lodash';
    export default {
        name: 'Index',
        data() {
            return {
                cooperateList: [
                    {cooperateUrl: require('../assets/hotel1.png')},
                    {cooperateUrl: require('../assets/hotel2.png')},
                    {cooperateUrl: require('../assets/hotel3.png')},
                    {cooperateUrl: require('../assets/logo.png')}
                ],
                style: ''
            }
        },
        components: {
          AboutHome,AboutOur,AboutOurThree
        },
        mounted() {
          console.log(window.innerHeight -60)
          console.log(document.body.offsetHeight)
          // this.style = `height:${window.innerHeight -60}px;width:100%;`
          // window.addEventListener("scroll", this.onScroll);
        },
        methods: {
          // onScroll: throttle(function (e) {
          //   console.log(e)
          //   let obj = document.getElementById("app")
          //   document.documentElement.scrollTop = document.documentElement.scrollTop + window.innerHeight-60;
          //   document.body.scrollTop = window.innerHeight;
          //   // console.log(oPos)
          // },500,{'trailing': false})
        },
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
  @import '../assets/scss/index.scss';
  @media screen and (min-width:0px) and (max-width:900px){
    // body {background-color:#f5f5f5;}
    .height{
      height: 800px;
    }
  }
  @media screen and (min-width:900px) and (max-width:1200px){
    // body {background-color:#f5f5f5;}
    .height{
      height: 800px;
    }
  }
  @media screen and (min-width:600px) and (max-width:900px){
    // body {background-color:#f5f5f5;}
    .height{
      height: 870px;
    }
  }
  @media screen and (min-width: 1200px) {
    .height{
      height: calc(100vh - 60px);
    }
  }
  .el-carousel__item h3 {
    color: #475669;
    font-size: 18px;
    opacity: 0.75;
    /*line-height: 400px;*/
    margin: 0;
  }

  .el-carousel__item:nth-child(2n) {
    background-color: #99a9bf;
  }

  .el-carousel__item:nth-child(2n+1) {
    background-color: #d3dce6;
  }

  // .height{
  //   height: calc(100vh - 60px);
  // }
  @media screen and (max-width: 768px) {
      // .height{
      //   height: 730px;
      // }
  }
  .carousel-wrap {
    width: 100%;
    /* height: 500px; */
    // display: inline-block;
  }
  .el-carousel__container {
    height: 100% !important;
  }
  .carousel-cooperate-list {
    display: flex;
    width: 80%;
    height: 300px;
    margin: 0 auto;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: center;
  }

  .carousel-cooperate-list > img {
    width: 25%;
    height: 120px;
    margin: 10px 20px;
  }

  .carousel-graphic {
    width: 40%;
    height: 400px;
    float: left;
    margin-left: 50px;
  }

  /*.carousel-graphic>img{
    width: 100%;
    height: 400px;
  }*/
  .carousel-text {
    width: 40%;
    height: 400px;
    float: right;
    margin-right: 70px;
  }

  .carousel-text > h1 {
    line-height: 50px;
  }

  .carousel-text > p {
    line-height: 30px;
  }

  .carousel-code {
    width: 100%;
    display: inline-flex;
    flex-direction: row;
    align-items: center;
    justify-items: center;
    flex-wrap: wrap;
    justify-content: space-around;
  }

  .carousel-code img {
    width: 150px;
    height: 150px;
  }

  .carousel-app {
    width: 40%;
    height: 400px;
    float: left;
  }

  .carousel-app-introduce {
    width: 60%;
    height: 400px;
    float: right;
  }

  .carousel-app-circle {
    width: 100%;
    height: 200px;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
  }

  .circle {
    display: inline-flex;
    width: 60px;
    height: 60px;
    border-radius: 50%;
    background: #eee;
    color: #8d8d8d;
    justify-content: center;
    align-items: center;
  }

  .carousel-app-text {
    text-align: left;
    line-height: 40px;
  }

  .carousel-cooperate > h2 {
    line-height: 60px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/Index.vue